import React from "react";

export function Contacts() {
	return <div>Contacts page</div>;
}
